import { render, staticRenderFns } from "./ReferencesPanel.vue?vue&type=template&id=109933b0"
import script from "./ReferencesPanel.vue?vue&type=script&lang=js"
export * from "./ReferencesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports